import React, { useState } from 'react';
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { IDocumentLoader } from './types/document';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import AboutDocumentDialog from './about';
import { L10n } from '@syncfusion/ej2-base';
import { PdfViewerComponent, Toolbar, Magnification, Navigation, BookmarkView,
    ThumbnailView, Print, TextSelection, TextSearch, FormFields, Inject} from '@syncfusion/ej2-react-pdfviewer';
import pdfLocale from './locale/pdf.locale.json';

interface IWordAppProps {
    enableRTL: boolean;
    documentLoader: IDocumentLoader;
}

function blobToBase64(blob: Blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

function PDFApp(props: IWordAppProps) {
    const enableRTL : boolean = props.enableRTL;
    const documentLoader : IDocumentLoader = props.documentLoader;

    const [ documentName, setDocumentName ] = useState <string>('');
    const [ loaded, setLoaded ] = useState <number>(0);
    
    const onLoadDefault = async () : Promise<void> => {

        setDocumentName(documentLoader.document.name);
        
        var data = new Blob([new Uint8Array(props.documentLoader.document.body.data)]);
        const pdfStr : string | unknown = await blobToBase64(data);

        if (pdfStr) {
            var viewer : any | null = document.getElementById('container');
            if (viewer) {
                viewer.ej2_instances[0].load(pdfStr);
                setLoaded(1);
            } else
                setLoaded(2);
        } else 
            setLoaded(2);
    }

    function downloadDocument() : void {
        var data = new Blob([new Uint8Array(props.documentLoader.document.body.data)]);
        var url = window.URL.createObjectURL(data);
        const tempLink = document.createElement('a');
        tempLink.href = url;
        tempLink.setAttribute('download', props.documentLoader.document.name + ' (v' + props.documentLoader.document.metadata.versionNumber.toString() + ')' + 
            props.documentLoader.document.metadata.file.ext);
        tempLink.click();
        window.URL.revokeObjectURL(url);
    }
    
    let toastInstance: ToastComponent;
    function toastCreated(): void {
        if (loaded === 2)
            toastInstance.show();
    }
    
    L10n.load(pdfLocale);

    return (
        <React.Fragment>
            <div className="row" style={{ maxHeight: '40px' }}>
                <div className="col-md-12">
                <AppBarComponent mode="Dense" colorMode="Primary">                    
                    <AboutDocumentDialog documentLoader={documentLoader}/>
                    <span className="dense">Contentum: {documentName}</span>
                    <div className="e-appbar-spacer"></div>
                    <ButtonComponent cssClass='e-inherit login' iconCss="e-icons e-download" onClick={() => { downloadDocument() }}>Завантажити</ButtonComponent>
                </AppBarComponent>
                </div>
            </div>
            <div id="editorContainerElement">
                <PdfViewerComponent
                    id="container"
                    created={onLoadDefault}
                    //serviceUrl="http://10.0.130.8:6003/api/pdfviewer"
                    serviceUrl="https://document.e-contentum.com/api/pdfviewer"
                    //serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/pdfviewer" 
                    //resourceUrl="https://cdn.syncfusion.com/ej2/25.1.35/dist/ej2-pdfviewer-lib"
                    width={window.innerWidth + 'px'}
                    height={window.innerHeight - 40 + 'px'}
                    enableNavigation={true}
                    locale="uk-UA"
                    toolbarSettings={{ 
                        showTooltip : true, 
                        toolbarItems: [
                            'PageNavigationTool', 
                            'MagnificationTool', 
                            'PanTool', 
                            'SelectionTool', 
                            'SearchOption', 
                            'PrintOption'
                        ], 
                    }}
                >
                    <Inject services={[ Toolbar, Magnification, Navigation, BookmarkView, ThumbnailView, Print, TextSelection, TextSearch, FormFields ]}/>
                </PdfViewerComponent>
            </div>
            { (loaded === 1 || loaded === 2) &&
                <ToastComponent 
                    ref={(toast: any) => toastInstance = toast!} 
                    title="На жаль, сталася помилка"
                    content="Ми не можемо отримати документ з Contentum"
                    created={toastCreated} 
                    showProgressBar={true}
                    timeOut={10000}
                    position={{ X: 'Right', Y: 'Top' }}
                    enableRtl={enableRTL}
                />
            }
        </React.Fragment>
    )
}

export default PDFApp;